import useSample from 'hooks/useSample';
import type { EmployeeQuote } from '../quotes';

const useEmployeeQuote = (quotes: EmployeeQuote[]): EmployeeQuote => useSample(quotes);
export { useEmployeeQuote as default, EmployeeQuote };
